export default function () {
	return new Promise((resolve) => {
		fetch(`/wp-json/blacklist/v1/general`, {
			method: 'GET',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then((res) => res.json())
			.then((response) => {
				resolve(response);
			})
			.catch((error) => {
				console.error(error);
			});
	});
}
